module.exports = __webpack_public_path__ + "static/media/Rosalind R.8ca99798.jpg";